
import ServicepointEditableDetail from "@/components/servicepoint/ServicepointEditableDetail.vue";
import { IServicepointDetail } from "@/entities";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component({
  name: "edit-servicepoint-page",
  components: {
    ServicepointEditableDetail,
  },
})
export default class ServicepointEditPage extends Vue {
  @Action("fetchServicepointDetail") fetchServicepointDetail!: (
    idServicepoint: number
  ) => Promise<IServicepointDetail>;

  public servicepointDetail: IServicepointDetail | null = null;

  $refs!: {
    servicepointEditableDetail: InstanceType<typeof ServicepointEditableDetail>;
  };

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    this.servicepointDetail = await this.fetchServicepointDetail(Number(this.$route.params.id));
  }

  async handleFetchServicepointRequired(): Promise<void> {
    this.servicepointDetail = await this.fetchServicepointDetail(Number(this.$route.params.id));
    this.$nextTick(() => {
      this.$refs.servicepointEditableDetail?.initializeFormData();
    });
  }
}
